export default Object.freeze({
  bySite: [],
  byEmployee: [],
  byMobilePatrol: [],
  details: [],
  loading: true,
});
